import { SoldProductCard } from '@components/sell/catalog/products/list/list-item/item-cta/drop-price/soldProduct/sold-product-card/sold-product-card';
import { SimilarSoldProduct } from '@interfaces/models/sales/domain/SellerPrice';
import { SwiperSlide } from 'swiper/react';
import ProductSlider, { ProductSliderProps } from './product-slider';
import styles from './product-slider.module.scss';

type SoldProductsSlider = Omit<ProductSliderProps<SimilarSoldProduct>, 'children'>;

const SoldProductSlider = ({ products }: SoldProductsSlider) => {
  return (
    <ProductSlider products={products}>
      {products.map((product, index) => (
        <SwiperSlide
          key={product.productId}
          tag="li"
          className={styles.product_slider__swiper_slide}
          data-cy={`sold-product-slider-slide-${index}`}
        >
          <SoldProductCard
            item={product}
            customClass={styles.product_slider__product_card}
          />
        </SwiperSlide>
      ))}
    </ProductSlider>
  );
};

export default SoldProductSlider;
